"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconsMapping = void 0;
var _socialIcons = require("@ori-ui/social-icons");
const iconsMapping = exports.iconsMapping = {
  blogger: {
    icon: _socialIcons.BloggerRing
  },
  douban: {
    icon: _socialIcons.Douban
  },
  email: {
    icon: _socialIcons.EmailRing
  },
  facebook: {
    icon: _socialIcons.Facebook
  },
  instagram: {
    icon: _socialIcons.InstagramRing
  },
  line: {
    icon: _socialIcons.Line
  },
  link: {
    icon: _socialIcons.Link
  },
  messenger: {
    icon: _socialIcons.Messenger
  },
  odnoklassniki: {
    icon: _socialIcons.OdnoklassnikiRing
  },
  pinterest: {
    icon: _socialIcons.Pinterest
  },
  qq: {
    icon: _socialIcons.QqRing
  },
  qzone: {
    icon: _socialIcons.Qzone
  },
  renren: {
    icon: _socialIcons.Renren
  },
  rss: {
    icon: _socialIcons.RssRing
  },
  signal: {
    icon: _socialIcons.Signal
  },
  telegram: {
    icon: _socialIcons.Telegram
  },
  tqq: {
    icon: _socialIcons.TqqRing
  },
  twitter: {
    icon: _socialIcons.XRing
  },
  viber: {
    icon: _socialIcons.Viber
  },
  vkontakte: {
    icon: _socialIcons.Vkontakte
  },
  wechat: {
    icon: _socialIcons.Wechat
  },
  weibo: {
    icon: _socialIcons.Weibo
  },
  whatsapp: {
    icon: _socialIcons.WhatsappFilled
  },
  x: {
    icon: _socialIcons.XRing
  },
  youku: {
    icon: _socialIcons.Youku
  },
  youtube: {
    icon: _socialIcons.YoutubeRing
  }
};
